export default __webpack_public_path__ + "static/B0160-b5f7d2df660ed6b03581f52b5b040ba2.png";